import React from 'react'

function RightLineArrowIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.001" height="10.003" viewBox="0 0 16.001 10.003" {...props}>
      <g data-name="Group 53441" transform="translate(-59 -23)">
        <path
          fill="#263238"
          d="M22.227 7.565l1.613-1.689H11v-1.75h12.839l-1.612-1.689V0L27 5l-4.774 5z"
          data-name="Union 28"
          transform="translate(48 23)"
        ></path>
      </g>
    </svg>
  )
}

export default RightLineArrowIcon
